import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { resourcesApi, SpendingSummary } from '@/services/api/agentApi';
import * as errorUtils from '@/utils/errors';

interface UsageStoreState {
  spending: SpendingSummary | null;
  isLoading: boolean;
  error: string | null;
  days: 7 | 14 | 30;
}

interface UsageStoreActions {
  fetchSpending: (days?: number) => Promise<void>;
  setDays: (days: 7 | 14 | 30) => void;
}

export const useUsageStore = create<UsageStoreState & UsageStoreActions>()(
  immer((set, get) => ({
    spending: null,
    isLoading: false,
    error: null,
    days: 7,

    fetchSpending: async (days?: number) => {
      set((s) => { s.isLoading = true; s.error = null; });
      try {
        const d = days || get().days;
        const result = await resourcesApi.getSpending(d);
        set((s) => { s.spending = result.data; s.isLoading = false; });
      } catch (error: unknown) {
        set((s) => { s.error = errorUtils.getErrorMessage(error); s.isLoading = false; });
      }
    },

    setDays: (days) => {
      set((s) => { s.days = days; });
      get().fetchSpending(days);
    },
  }))
);

// Reset on logout to prevent data leakage between sessions
if (typeof window !== 'undefined') {
  import('../auth/auth-store').then(({ useAuthStore }) => {
    useAuthStore.subscribe(
      (state) => state.isAuthenticated,
      (isAuthenticated, prev) => {
        if (prev && !isAuthenticated) {
          useUsageStore.setState({ spending: null, isLoading: false, error: null, days: 7 });
        }
      }
    );
  });
}
